import {ChangeDetectionStrategy, Component, Inject, OnInit, Optional} from "@angular/core";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";

@Component({
    selector: 'close-dialog',
    templateUrl: './confirm-dialog.component.html',
    styleUrls: ['./confirm-dialog.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ConfirmDialogComponent implements OnInit{
    reason: string = '';
    closedTicket: boolean = null;

    constructor(public dialogRef: MatDialogRef<ConfirmDialogComponent>,
                @Optional() @Inject(MAT_DIALOG_DATA) public data: {closed: boolean, reason: string}) {}

    ngOnInit(): void {
        this.closedTicket = this.data.closed
    }

    ticketAction() {
        this.dialogRef.close({confirm: true, reason: this.reason})
    }
}
